module.exports = __webpack_public_path__ + "static/fipcmintorg3-22c369891cd17d99f2f827abb911015c.jpeg";